import { AeoOnboardingPhaseKindSchema } from "@redotech/redo-model/aeo/onboarding";
import * as z from "zod/v4";

const AeoOnboardingPhaseSchema = z.object({
  phase: AeoOnboardingPhaseKindSchema,
  isComplete: z.boolean(),
});
export type AeoOnboardingPhase = z.infer<typeof AeoOnboardingPhaseSchema>;

const AeoOnboardingProgressSchema = z.discriminatedUnion("hasBeenOnboarded", [
  z.object({ hasBeenOnboarded: z.literal(true) }),
  z.object({
    hasBeenOnboarded: z.literal(false),
    onboardingStatus: z.array(AeoOnboardingPhaseSchema),
  }),
]);
export type AeoOnboardingProgress = z.infer<typeof AeoOnboardingProgressSchema>;

export const getAeoOnboardingProgress = {
  name: "getAeoOnboardingProgress" as const,
  input: z.object({}),
  output: AeoOnboardingProgressSchema,
};
